// extracted by mini-css-extract-plugin
export default {"button":"Connect_button__U1PbC","msg":"Connect_msg__D0Qsn"};